import lang from '../i18n'
import analysis from './AnalysisStore'

export default {
  lang,
  analysis
}



// WEBPACK FOOTER //
// ./src/store/index.js